<ng-container>
  <a class="mdl-navigation__link" [routerLink]="['/portfolioconfiguration']"></a>  
</ng-container>
